import { CreateCouponInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const CreateCouponInputSchema: z.ZodType<CreateCouponInput> = z.object({
  code: z.string(),
  percent_off: z.string(),
  redeem_by: z.string().optional(),
  max_redemptions_customers: z.string().optional(),
});
